import React, { useState, useEffect } from "react";
import { Grid, Typography, Box } from "@material-ui/core";
import ButtonAtom from "../../component/ButtonAtom/index.jsx";
import TextfieldAtom from "../../component/Textfield/index.jsx";
import { makeStyles } from "@material-ui/styles";
import firebase from "../../config/firebase/index";
import Otp_Verification from "../otp_verification/Otp_Verification";
import { useHistory, withRouter } from "react-router-dom";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CircularIndeterminate from '../../component/Loader/index';

import ReactGA from 'react-ga';
import { Button, CircularProgress, TextField } from "@mui/material";
import encSecret from "../../config/encryption/index.js";
import { Header } from "antd/lib/layout/layout";
var CryptoJS = require("crypto-js");


const Sales_Login = () => {
  const history = useHistory();
  const [mynumber, setnumber] = useState();
  const [show, setshow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [Otp, setOtp] = useState();


  const handleNumberChange = (e) => {
    // console.log(e.target.value);
    if ((e.target.value).length === 0) {
      setnumber(e.target.value);
    }
    else if ((e.target.value).length > 0 && ((e.target.value).length < 10 || (e.target.value).length > 10)) {
      setnumber(e.target.value);
    }
    else if ((e.target.value).length === 10) {
      setnumber(e.target.value);
    }

  };


  useEffect(() => {
    localStorage.setItem("Sales Phone Number", mynumber);

  });
  // Sent OTP
  const click = () => {

    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
      }
    );
    const appVerifier = window.recaptchaVerifier;
    setLoading(true);
    firebase
      .auth()
      .signInWithPhoneNumber("+91" + mynumber, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        setshow(true);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  const login = () => {
    setLoading(true);
    if (Otp === null) return;
    window.confirmationResult
      .confirm(Otp)
      .then((result) => {
        existingUser();
        // {<Spinner animation="border" variant="primary" />}

      })
      .catch((err) => {
        setLoading(false);
        alert("Wrong code");

      });
  };

  const existingUser = () => {
    setLoading(true);
    firebase.database().ref("SalesTeam").orderByChild("PhoneNo")
      .equalTo(localStorage.getItem("Sales Phone Number")).once("value", snapshot => {
        const userData = snapshot.val();
        const user = [];
        for (const key in userData) {
          const quoteObj = {
            id: key,
            ...userData[key],
          };
          user.push(quoteObj);
        }
        if (userData) {
          localStorage.setItem("isSalesLoggedIn", true);
          localStorage.setItem("salesUser", JSON.stringify(user));
          setLoading(false);

          history.push("/sales-dashboard");
        }
        else {
          setLoading(false);
          const salesUser = firebase.database().ref("SalesTeam").push({
            PhoneNo: mynumber,
            name: "User" + Date.now(),
            dealerIds: [],
            createAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          });

          if (salesUser) {
            // console.log("New User:: ", salesUser);
            // localStorage.setItem("salesUser", JSON.stringify(salesUser));
            history.push("/sales-dashboard");
            localStorage.setItem("isSalesLoggedIn", true);
          }
        }

      })
  }

  const otpHandleChange = (otp) => {
    // console.log(otp.target.value);
    setOtp(otp.target.value);
  };

  const classes = useStyles();
  return (

    <Grid className={classes.commonFullSection}>
      <Header style={{paddingTop: 50, textAlign: "center"}}>
        <Typography variant="h5" style={{ fontWeight: 600 }} className={classes.purpuleColor}>
          Saudebazi
        </Typography>

        <Box mt={4} mb={3}>
          <Typography variant="h4" style={{ fontWeight: 500 }} >
            Sales Dashboard
          </Typography>
        </Box>
      </Header>
      <Grid className={classes.commonMidSection} >



        <Box mb={3} >
          <Box className={classes.headerBrowser2}>
            <TextField id="outlined-basic" type={'number'} onChange={handleNumberChange} label="Enter your phone number" variant="outlined" style={{ 'width': '100%' }} />
          </Box>
          <Box className={classes.headerBrowser2} style={{ display: show ? "block" : "none" }}>
            <TextField id="outlined-basic" type={'text'} onChange={otpHandleChange} label="Enter OTP" variant="outlined" style={{ 'width': '100%' }} />
          </Box>

        </Box>
        <div id="recaptcha-container"></div>
        {loading ? <CircularProgress /> :
          <></>}
        <Box mb={3} style={{ display: !show ? "block" : "none" }}>
          <Button color="secondary" variant="outlined" onClick={click}>{'Get OTP'}</Button>
        </Box>
        <Box mb={3} style={{ display: show ? "block" : "none" }}>
          <Button color="secondary" variant="outlined" onClick={login}>{'Login'}</Button>
        </Box>
      </Grid>
      <Typography variant="caption" gutterBottom className={classes.marginTopAuto}>
        {/* Call 8696965308 for access related queries. */}
      </Typography>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  commonFullSection: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  commonMidSection: {
    maxWidth: 540,
    background: '#fff',
    // boxShadow: '0 0 5px #eee',
    padding: 20,
    paddingTop: 0,
    textAlign: 'center',
    marginTop: 'auto',
    width: 'calc(100% - 60px)',
  },
  marginTopAuto: {
    marginTop: 'auto',
    paddingBottom: '50px',
    fontSize: '100%'
  },
  labelAlign: {
    textAlign: 'left',
    marginRight: '120px',
    marginTop: 34,
  },
  labelAlign2: {
    textAlign: 'left',
    marginRight: '80px',
    marginLeft: "20px",
    marginTop: 15,
  },
  labelAlign3: {
    textAlign: 'left',
    marginLeft: '20px',
    marginTop: 15,
    fontSize: '14px'
  },
  purpuleColor: {
    color: '#53252f',
  },
  headerBrowser2: {
    background: '#fff',
    color: 'black',
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 20px',
    alignItems: 'center',
    position: 'relative',
    '& input': {
      paddingLeft: 10,
    }

  },
  headerBrowser3: {
    position: 'absolute',
    top: 25,
    left: 30,
    color: '#53252f',
  },
  inputMargin: {
    marginLeft: '20px',
    marginRight: '20px',
  }
}));

export default withRouter(Sales_Login);